import { render, staticRenderFns } from "./AmazonumsaetzeTabelle.vue?vue&type=template&id=f9d83142&scoped=true&"
import script from "./AmazonumsaetzeTabelle.vue?vue&type=script&lang=js&"
export * from "./AmazonumsaetzeTabelle.vue?vue&type=script&lang=js&"
import style0 from "./AmazonumsaetzeTabelle.vue?vue&type=style&index=0&id=f9d83142&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d83142",
  null
  
)

export default component.exports